import { createPatchAsyncSlice } from '@sonar-software/xuder';
import { getAdminFeatureFlagsSlice } from '../get';
import { patchAdminFeatureFlagById } from '../../../api';
import { updateAdminFeatureFlagSlice } from '../update';

export const patchAdminFeatureFlagByIdSlice = createPatchAsyncSlice({
	httpSagaOptions: {
		preRequestActionCreators: [
			updateAdminFeatureFlagSlice.syncActionCreator
		],
		successActionCreators: [
			getAdminFeatureFlagsSlice.asyncActionCreators.repeatGetAdminFeatureFlags
		]
	},
	name: 'AdminFeatureFlagById',
	receive: false,
	request: true,
	requestHandler: patchAdminFeatureFlagById
});
